import { fmtDay } from '../../epmHelpers';

export const SIGN_OFF_ID = 'pr-signoff';

// Build events happened in the days before go-live
export const eventDay = (days, time) => `${fmtDay(days).toUpperCase()} ${time}`;

// Saved variants are lettered from A
export const variantLetter = (index) => String.fromCharCode(65 + index);

export const IMAGE_FILE = /\.(png|jpe?g|gif|webp|svg)$/i;
export const isImageFile = (variant) =>
    IMAGE_FILE.test(variant?.key || String(variant?.source_url || '').split('?')[0]);

// Only the stored fields go back to the API (the URL is re-signed on every read)
export const toVariantPayload = ({ _id, source_url, key, details }) => ({
    ...(_id && { _id: String(_id) }),
    source_url,
    key,
    details,
});

export const marker = (item) =>
    item.isOneOff ? (item.required ? 'REQ' : 'OPT') : item.added ? 'ADDED' : item.required ? 'REQ' : 'OPT';

export const lowerFirst = (text) =>
    String(text || '').charAt(0).toLowerCase() + String(text || '').slice(1);

// The platform activity's state follows the test through its life
export const bindingState = (status, schedule) => {
    switch (status) {
        case 'SCHEDULED':
            return { text: `created · starts ${fmtDay(schedule?.start_day)}`, badge: 'scheduled' };
        case 'LIVE':
            return { text: `live since ${fmtDay(schedule?.start_day)}`, badge: 'live' };
        case 'ANALYSING':
        case 'CONCLUDED':
            return { text: `deactivated ${fmtDay(schedule?.end_day)}`, badge: 'inactive' };
        default:
            return { text: 'created · not started', badge: 'draft' };
    }
};

export const formatAuditDateTime = (dateTime) => {
    if (!dateTime) return '—';
    try {
        const d = new Date(dateTime);
        if (isNaN(d.getTime())) return String(dateTime);
        return d.toLocaleString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        });
    } catch {
        return String(dateTime);
    }
};

